export default "__VITE_ASSET__B8qyvfAK__"